// app/javascript/controllers/faq_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "expandIcon", "collapseIcon"]

  toggle(event) {
    // Tıklanan butonun en yakın FAQ item'ını bul
    const item = event.currentTarget.closest('[data-controller="faq"]')
    const isExpanded = item.getAttribute('data-expanded') === 'true'

    // Toggle expanded state
    item.setAttribute('data-expanded', !isExpanded)

    // İkonları toggle et
    this.expandIconTarget.classList.toggle('hidden')
    this.collapseIconTarget.classList.toggle('hidden')

    // Content'i toggle et
    this.contentTarget.classList.toggle('hidden')
  }
}
